import { createComponent } from '@front/utils/alpine';
const request = async (route) => {
    const response = await fetch(route, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }
    return response.json();
};
const postRequest = async (route, content, csrfToken) => {
    const response = await fetch(route, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'X-CSRF-TOKEN': csrfToken || '',
        },
        body: content,
    });
    if (!response.ok) {
        throw new Error(`Error! status: ${response.status}`);
    }
    return true;
};
const Modal = createComponent(() => ({
    lists: [],
    csrf: '',
    counter: 0,
    showInput: false,
    isOpen: false,
    choice: '',
    chosenId: 0,
    isWishlistModalOpen: false,
    end: false,
    async init() {
        const app = JSON.parse(document
            .querySelector('meta[name="app"]')
            .getAttribute('content'));
        this.csrf = app.token;
        this.lists = await request('/wishlist/lists');
    },
    save() {
        if (!this.counter && this.choice != 'Ajouter à une liste existante') {
            this.saveChoice();
        }
        else {
            this.saveList();
        }
    },
    prepareWishlistModal() {
        this.isWishlistModalOpen = true;
    },
    async saveChoice() {
        if (this.chosenId > 0) {
            const formData = new FormData();
            formData.append('wishlistId', JSON.stringify(this.chosenId));
            await postRequest('/wishlist/fill', formData, this.csrf);
            this.end = true;
        }
    },
    async saveList() {
        const input = this.$refs.input;
        if (input.value.length) {
            const formData = new FormData();
            formData.append('wishlist', JSON.stringify(input.value));
            if (await postRequest('/wishlist/create', formData, this.csrf)) {
                this.lists = await request('/wishlist/lists');
                this.showInput = false;
                input.value = '';
                this.counter = 0;
            }
        }
    },
}));
const Wishlist = { Modal };
export { Wishlist };
